export function SkipForNowButton(props: React.ButtonHTMLAttributes<HTMLButtonElement>): React.ReactNode {
  return (
    <button className="text-body text-on-surface-variant hover:text-on-surface" {...props}>
      <span className="hidden md:block">Skip for now</span>
      <span className="block md:hidden">Skip</span>
    </button>
  )
}
